import React from 'react'

import {
  BorderStyle,
  Box,
  Color,
  Display,
  FontWeight,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { onEnter } from 'utils/accessibility'

import { TabButtonProps } from './boxPricesTabsModels'

export const TabButton = ({ text, isActive, onClick }: TabButtonProps) => (
  <Box
    tabIndex={0}
    role="button"
    onClick={onClick}
    onKeyPress={onEnter(onClick)}
    display={Display.InlineBlock}
    color={isActive ? Color.Secondary_400 : Color.NeutralGrey_900}
    bg={isActive ? Color.White : Color.NeutralGrey_50}
    paddingV={2}
    borderStyle={BorderStyle.Solid}
    borderWidth={0.5}
    borderColor={Color.ColdGrey_200}
    borderBottomWidth={isActive ? 0 : 0.5}
    width="100%"
    style={{
      borderRadius: '3px 3px 0px 0px',
      cursor: 'pointer',
      outline: 'none',
    }}
    data-testid="tabButton"
  >
    <Text
      size={3}
      fontWeight={FontWeight.Bold}
      textAlign={TextAlign.Center}
      data-testid="tabButtonText"
    >
      {text}
    </Text>
  </Box>
)
